import type { PartnerTrackingParamUnion } from '../types'
import { useState } from '#imports'
import type { LocationQuery } from '#vue-router'

export const usePartner = () => {
    const partnerQueryParams: Array<PartnerTrackingParamUnion> = ['partner', 'partner_id', 'partner_user_id', 'partner_username', 'token', 'campaign', 'coid', 'fbclid', 'gclid', 'gbraid']
    const isFromPartner = useState<boolean>('isFromPartner', () => false)

    function hasPartnerQueryParams(query: LocationQuery, validQueryParams = partnerQueryParams): boolean {
        return validQueryParams.some(validQueryKey => !!query[validQueryKey])
    }

    return {
        isFromPartner,
        hasPartnerQueryParams,
        partnerQueryParams
    }
}
